// extracted by mini-css-extract-plugin
export default {"progress":"Progress_progress__UBQ6A","progress__icon":"Progress_progress__icon__OzRlq","progress__icon_mistake":"Progress_progress__icon_mistake__MJmxd"};